import React from 'react'
import { MessageSquare } from 'lucide-react'
import { cn } from '@/lib/utils'

interface AskTcsAiToggleProps {
  isOverlayOpen: boolean
  toggleButtonRef?: React.RefObject<HTMLButtonElement>
  onClick: () => void
}

/**
 * AskTcsAiToggle — top-bar button that opens/closes the AI chat overlay.
 *
 * Per brand guide §36 Toggle button (v2):
 *  - Label: "Ask TCS AI" — state-invariant (never changes to "Close" / "Hide")
 *  - Icon: MessageSquare (15px)
 *  - aria-pressed reflects open state
 *  - Blue-tint active visual when overlay is open
 */
export const AskTcsAiToggle: React.FC<AskTcsAiToggleProps> = ({
  isOverlayOpen,
  toggleButtonRef,
  onClick,
}) => {
  return (
    <button
      type="button"
      ref={toggleButtonRef}
      className={cn(
        'inline-flex items-center gap-1.5 h-[34px] px-3 rounded-[7px] border-[1.5px]',
        'text-xs font-semibold whitespace-nowrap transition-all duration-150',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focusRing focus-visible:ring-offset-2',
        isOverlayOpen
          ? 'bg-accent-background border-[#BFDBFE] text-accent'
          : 'bg-card border-border text-secondary hover:bg-accent-background hover:border-[#BFDBFE] hover:text-accent',
      )}
      aria-pressed={isOverlayOpen}
      aria-label="Ask TCS AI"
      onClick={onClick}
    >
      <MessageSquare size={15} aria-hidden="true" />
      Ask TCS AI
    </button>
  )
}
